/** The box parse plus the `resolution` of the SDF cell grid (`scene/3d/gpu_particles_collision_3d.cpp:605-608`). */
import { GPU_PARTICLES_COLLISION_SDF_3D_DEFAULT_RESOLUTION, GPU_PARTICLES_COLLISION_SDF_3D_RESOLUTION_VALUES, } from '../../../../godot/scene/particlesCollision3d';
import { enumOr } from '../../../../parser/valueParsers';
import { parseBoxVolume } from './parseBoxVolume';
export function parseSdfVolume(heading, properties) {
    return {
        ...parseBoxVolume(heading, properties),
        resolution: enumOr(properties.resolution, GPU_PARTICLES_COLLISION_SDF_3D_DEFAULT_RESOLUTION, GPU_PARTICLES_COLLISION_SDF_3D_RESOLUTION_VALUES, `${heading.type} resolution`),
    };
}
//# sourceMappingURL=parseSdfVolume.js.map